import { UserPlus, UserCheck } from 'lucide-react'
import { useIsFollowing, useFollowPlayer, useUnfollowPlayer } from '../hooks/useFollows'

export default function FollowButton({ playerId }) {
  const isFollowing = useIsFollowing(playerId)
  const followMutation = useFollowPlayer()
  const unfollowMutation = useUnfollowPlayer()
  const isPending = followMutation.isPending || unfollowMutation.isPending

  const handleClick = () => {
    if (isPending) return
    if (isFollowing) {
      unfollowMutation.mutate(playerId)
    } else {
      followMutation.mutate(playerId)
    }
  }

  return (
    <button
      onClick={handleClick}
      disabled={isPending}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '0.375rem',
        padding: '0.5rem 1rem',
        borderRadius: '2rem',
        fontSize: '0.8125rem',
        fontWeight: '600',
        cursor: isPending ? 'wait' : 'pointer',
        transition: 'all 0.15s',
        border: isFollowing
          ? '1.5px solid var(--border-color)'
          : '1.5px solid var(--accent-primary)',
        backgroundColor: isFollowing
          ? 'transparent'
          : 'var(--accent-primary)',
        color: isFollowing
          ? 'var(--text-secondary)'
          : '#fff',
        opacity: isPending ? 0.6 : 1,
      }}
    >
      {isFollowing ? <UserCheck size={14} /> : <UserPlus size={14} />}
      {isFollowing ? 'Following' : 'Follow'}
    </button>
  )
}
